(function () {
  var THRESHOLD = 2000; // 20 EUR en centimes
  var css = '.ys-bar{margin:1rem 0;padding:1rem 1.2rem;border:1px solid #d4af37;border-radius:8px;background:#fffaf2;color:#2b1a14;font-size:1.4rem;line-height:1.4;text-align:center}' +
    '.ys-bar strong{color:#b02a37}' +
    '.ys-track{position:relative;display:block;height:10px;border-radius:10px;background:#eadfd0;margin-top:.8rem;overflow:hidden}' +
    '.ys-fill{position:absolute;left:0;top:0;bottom:0;display:block;min-width:10px;border-radius:10px;background:#b02a37;background-image:linear-gradient(90deg,#b02a37,#d4af37);transition:width .4s ease}' +
    '.ys-ship{margin:1rem 0;font-size:1.4rem;color:#2b1a14}' +
    '.ys-ship strong{color:#b02a37}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function fmt(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  function pctOf(total) {
    if (total >= THRESHOLD) return 100;
    return Math.max(5, Math.round(total / THRESHOLD * 100));
  }

  function html(total) {
    var track = '<span class="ys-track"><span class="ys-fill" data-pct="' + pctOf(total) + '"></span></span>';
    if (total >= THRESHOLD) {
      return '🎉 <strong>Livraison offerte</strong> sur votre commande (France) !' + track;
    }
    return '🚚 Plus que <strong>' + fmt(THRESHOLD - total) + '</strong> pour la livraison offerte (France)' + track;
  }

  function applyFill(bar) {
    var f = bar.querySelector('.ys-fill');
    if (f) f.style.width = f.getAttribute('data-pct') + '%';
  }

  var lastTotal = null;
  var busy = false;

  function place(total) {
    var targets = [];
    var drawer = document.querySelector('cart-drawer .drawer__header');
    if (drawer) targets.push({ el: drawer, id: 'ys-bar-drawer' });
    var page = document.querySelector('cart-items .title-wrapper-with-link');
    if (page) targets.push({ el: page, id: 'ys-bar-page' });
    targets.forEach(function (t) {
      var bar = document.getElementById(t.id);
      if (!bar) {
        bar = document.createElement('div');
        bar.id = t.id;
        bar.className = 'ys-bar';
        t.el.insertAdjacentElement('afterend', bar);
      }
      var h = html(total);
      if (bar.getAttribute('data-h') !== h) {
        bar.innerHTML = h;
        bar.setAttribute('data-h', h);
      }
      applyFill(bar);
      bar.style.display = total === 0 ? 'none' : '';
    });
  }

  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { lastTotal = cart.total_price; place(cart.total_price); })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function productLine() {
    if (document.getElementById('ys-ship')) return;
    var price = document.querySelector('.product__info-container [id^="price-"]');
    if (!price) return;
    var d = document.createElement('div');
    d.id = 'ys-ship';
    d.className = 'ys-ship';
    d.innerHTML = '🚚 <strong>Livraison offerte dès 20 €</strong> d’achat en France · sinon à partir de 2,90 €';
    price.insertAdjacentElement('afterend', d);
  }

  var timer = null;
  function onChange() {
    productLine();
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      var d = document.querySelector('cart-drawer .drawer__header');
      var p = document.querySelector('cart-items .title-wrapper-with-link');
      if (!d && !p) return;
      var missing = (d && !document.getElementById('ys-bar-drawer')) || (p && !document.getElementById('ys-bar-page'));
      if (lastTotal === null || missing) refresh(); else place(lastTotal);
    }, 150);
  }

  function start() {
    productLine();
    refresh();
    new MutationObserver(onChange).observe(document.body, { childList: true, subtree: true });
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      var p = origFetch.apply(this, args);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(refresh, 400); }).catch(function () {});
      }
      return p;
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
